import { version_options } from './Formatter';

const PROJECT_VERSION_V2 = version_options[0]?.value;
const PROJECT_VERSION_V3 = version_options[1]?.value;
const PROJECT_VERSION_V4 = version_options[2]?.value;

export type ShgcViewerFeatures = {
  shgcViewerAllowed?: boolean;
  shgcViewerStartDate?: string | Date | null;
};

/**
 * Legacy Revision Result UI (RatingMap / Report1045) for v2 projects.
 * Missing version is treated as v2 — same rule as api/server/worker/epc/epc.js.
 */
export const isLegacyRevisionResultProject = (
  projectVersion?: string | null
): boolean => !projectVersion || projectVersion === PROJECT_VERSION_V2;

export const isProjectVersionV3OrV4 = (projectVersion?: string): boolean =>
  projectVersion === PROJECT_VERSION_V3 || projectVersion === PROJECT_VERSION_V4;

export const isRevisionUpdatedAfterStartDate = (
  revisionUpdatedAt?: string | Date | null,
  startDate?: string | Date | null
): boolean => {
  if (!revisionUpdatedAt || !startDate) {
    return false;
  }
  return new Date(revisionUpdatedAt) > new Date(startDate);
};

export const isShgcViewerEnabled = (
  features: ShgcViewerFeatures | undefined,
  projectVersion: string | undefined,
  revisionUpdatedAt?: string | Date | null
): boolean =>
  !!(
    features?.shgcViewerAllowed &&
    features?.shgcViewerStartDate &&
    isProjectVersionV3OrV4(projectVersion) &&
    isRevisionUpdatedAfterStartDate(revisionUpdatedAt, features.shgcViewerStartDate)
  );
